var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"noise-wrap"},[_c('div',{staticClass:"noise-container"},[_c('div',{staticClass:"noise",on:{"click":function($event){return _vm.countClick()}}}),(_vm.game)?_c('div',{staticClass:"game"},[_c('pongGame')],1):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }